import { graphql } from 'gatsby';
import * as React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import { Layout } from '../components/layout';
import Seo from '../components/seo';
import PricesCalculator from '../components/Calculator/pricesCalculator';

const PricesCalculatorPage = ({ pageContext }) => {
  const { t } = useTranslation();
  return (
    <Layout>
      <Seo title={t('trans.pricesCalculator')} lang={pageContext.language} />
      <PricesCalculator />
    </Layout>
  );
};

export default PricesCalculatorPage;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
